import { css } from 'styled-components';

export const showOnDesktopOnly = (...attrs) => css`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    display: block;
    ${css.call(null, ...attrs)};
  }
`;

export const showOnMobileAndTabletOnly = (...attrs) => css`
  ${css.call(null, ...attrs)};

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumLarge}px) {
    display: none;
  }
`;

export const showOnMobileOnly = (...attrs) => css`
  ${css.call(null, ...attrs)};

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    display: none;
  }
`;
